import { RootState } from "../store";

export const selectMiners = (state: RootState) => state.minersState;
